import styled, { keyframes } from "styled-components";
import { media } from "@/styles/Qtheme.ts";
import { TabletCalVW } from "@utils/CalVW.tsx";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
`;

export const AssetOverallSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 50px;
    width: 1200px;
    animation: ${fadeInUp} 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;

    @media ${media.desktop} {
        width: ${TabletCalVW(900)};
    }

    @media ${media.mobile} {
        margin-top: 30px;
    }
`;

export const AssetOverallContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 30px;
    margin-bottom: 200px;
    gap: 32px;
    position: relative;

    > * {
        animation: ${fadeInUp} 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;

        &:nth-child(1) { animation-delay: 0.1s; }
        &:nth-child(2) { animation-delay: 0.2s; }
        &:nth-child(3) { animation-delay: 0.3s; }
    }

    @media ${media.mobile} {
        gap: 24px;
        margin-bottom: 150px;
    }
`;

export const AssetOverallHeaderSection = styled.div`
    width: 100%;
    padding: 40px;
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.itemBg};
    border-radius: 20px;
    border: 1px solid ${({theme}) => theme.COLORS.border || 'rgba(255, 255, 255, 0.1)'};
    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    position: relative;
    overflow: hidden;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
            circle,
            rgba(0, 122, 255, 0.04) 0%,
            rgba(255, 76, 0, 0.02) 40%,
            transparent 70%
        );
        transform: translate(-50%, -50%);
        pointer-events: none;
        animation: ${floatAnimation} 6s ease-in-out infinite;
    }

    &:hover {
        transform: translateY(-4px) scale(1.01);
        box-shadow:
            0 16px 48px rgba(0, 122, 255, 0.25),
            0 6px 16px rgba(255, 76, 0, 0.18),
            inset 0 1px 0 rgba(255, 255, 255, 0.25),
            0 0 0 1px rgba(0, 122, 255, 0.2),
            0 0 20px rgba(255, 76, 0, 0.1);
    }

    @media ${media.mobile} {
        padding: 28px 24px;
        border-radius: 16px;

        &:hover {
            transform: translateY(-2px) scale(1.005);
        }
    }
`;

export const FilterRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    margin-top: 20px;
    z-index: 1;
    position: relative;

    @media ${media.mobile} {
        gap: 12px;
    }
`;

export const FilterItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 140px;

    @media ${media.mobile} {
        min-width: 100%;
    }
`;

export const FilterLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${({theme}) => theme.secondaryTextColor || '#888'};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;

export const HeaderTitle = styled.h2`
    font-size: 24px;
    font-weight: 700;
    color: ${({theme}) => theme.COLORS.textw};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
    position: relative;

    @media ${media.mobile} {
        font-size: 20px;
    }
`;

export const HeaderDescription = styled.p`
    font-size: 14px;
    color: ${({theme}) => theme.secondaryTextColor || '#888'};
    margin: 8px 0 0 0;
    z-index: 1;
    position: relative;

    @media ${media.mobile} {
        font-size: 13px;
    }
`;
